const invoiceSerialList = [
  {
    id: "1",
    ruleType: "Manuel",
    serial: "IH",
    useForPassengerInvoice: "false",
    useForExportInvoice: "false",
    useForSGKInvoice: "false",
  },
  {
    id: "2",
    ruleType: "Manuel",
    serial: "IM",
    useForPassengerInvoice: "false",
    useForExportInvoice: "false",
    useForSGKInvoice: "false",
  },
];
export default invoiceSerialList;
